import styles from './tiledButtons.module.scss';

export default function TiledButtons({children}) {
	return <div className={styles.tiledButtonsContainer}>{children}</div>;
}
